import { useMutation } from 'react-apollo'

/**
 * The original useMutation hook enhanced for handling uploads
 *
 * @param {import('graphql').DocumentNode} mutation
 * @param {import('react-apollo').MutationHookOptions} options
 * @returns {import('react-apollo').MutationTuple<any, Record<string, any>>}
 */
export default function useUploadMutation(mutation, { context = {}, ...options } = {}) {
  return useMutation(mutation, { ...options, context: { ...context, upload: true } })
}
